import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import Datatable from "../../../components/features/Datatable"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import {
    deleteProductCalculation,
    disableAddModal,
    enableAddModal,
    fetchAllProductCalculations,
    selectBmraddProductCalculationModal,
    selectProductCalculationAll,
    selectProductCalculationLoading
} from "../../../slices/productCalculations";
import ProductCalculationsForm from "./ProductCalculationsForm";
import moment from 'moment'
import { truncateText } from '../../../../utils/utils'

const ProductCalculations = () => {
    const dispatch = useDispatch()
     const isLoading = useSelector(selectProductCalculationLoading)
    const addModal = useSelector(selectBmraddProductCalculationModal)
    const [rowData, setRowData] = useState(null)
    const [open, setOpen] = useState(false)
    const allProductCalculation = useSelector(selectProductCalculationAll)
    const columns = [
           {
        id: 'product_name',
        name: 'Product Name',
        align: "left",
        selector: row => {
            const fullText = row?.products?.map(p => p.product?.name)?.join(", ") || "-";
            return (
                <Tooltip title={fullText}>
                    <span>{truncateText(fullText, 50)}</span>
                </Tooltip>
            );
        },
        sortable: true
        },
        {
            id: 'description',
            name: 'Description',
            align: "left",
            selector: row => {
                const fullText = row?.description || "-";
                return (
                    <Tooltip title={fullText}>
                        <span>{truncateText(fullText, 50)}</span>
                    </Tooltip>
                );
            },
            sortable: true
        },
        {
            id: 'scheduled_by',
            name: 'Scheduled By',
            align: "center",
            selector: row => row?.creator?.name,
            sortable: true
        },
        {
            id: 'scheduled_at',
            name: 'Scheduled At',
            align: "center",
            selector: row => row?.created_at ? moment(row?.created_at).format('DD/MM/YYYY'):'',
            sortable: true
        },
        {
            id: 'type',
            name: 'Status',
            align: "center",
            selector: row => row.active ? <Typography className="text-[#369c50]">Active</Typography> : <Typography className="text-[#FF2023]">In-Active</Typography>,
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), setOpen(true) }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];

  const handleServerSideChange = async (params) => {
        try {
            await dispatch(fetchAllProductCalculations(params));
        } catch (error) {
            console.error("Error fetching program code data:", error);
        }
    };

    useEffect(() => {
          dispatch(disableAddModal())
        handleServerSideChange({ page: 1, per_page: 10 });
    }, []);
    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }
    const removeProductCalculation = async () => {
        const { id } = rowData
        await dispatch(deleteProductCalculation({ id }))
        setOpen(false)
    }
       const tableData = {
        items: allProductCalculation?.items || allProductCalculation?.data || [],
        total_count:
            allProductCalculation?.pageDetails?.no_of_records ||
            allProductCalculation?.no_of_records ||
            0,
        page: allProductCalculation?.pageDetails?.page || 1,
        per_page: allProductCalculation?.pageDetails?.per_page || 10,
    };

    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <BsModal size={'md'} open={addModal} onClose={handleCloseModal} title={rowData ? "EDIT PRODUCT CALCULATIONS" : "ADD NEW PRODUCT CALCULATIONS"}>
                <ProductCalculationsForm editData={rowData} />
            </BsModal>
             <Datatable
                columns={columns}
                data={tableData}
                loading={isLoading}
                title="Product Calculations"
                onServerSideChange={handleServerSideChange}
                remote={true}
                BtnComponent={<Button className="ml-2" onClick={() => (handleAddModal(), setRowData(null))}>Add New</Button>}
                searchPlaceholder="Search By Name / Product"
            />
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={removeProductCalculation}
            />
        </div>
    </div>
}
export default ProductCalculations